export const COPY_POLICIES = {
    title: {
        maxLength: 50,
        recommendedLength: 40,
        guidance: "For best results, aim for 40 characters or fewer (up to 50 allowed). Longer titles may wrap and affect the component's layout.",
    },
    description: {
        maxLength: 500,
        recommendedLength: 160,
        guidance: "For best results, aim for 160 characters or fewer (up to 500 allowed). Longer copy can change the component's spacing and visual balance.",
    },
};
export const TITLE_COPY_LIMITS = {
    copyRole: "title",
    maxLength: COPY_POLICIES.title.maxLength,
};
export const DESCRIPTION_COPY_LIMITS = {
    copyRole: "description",
    maxLength: COPY_POLICIES.description.maxLength,
};
/** Accordion headings allow longer questions and section titles. */
export const ACCORDION_TITLE_COPY_LIMITS = {
    ...TITLE_COPY_LIMITS,
    maxLength: 150,
};
//# sourceMappingURL=copy-policy.js.map